import http from '@/server/httpServer.js'

/**
 *
 * @return {promise}
 *
 */
/* 字典 */
export const searchDictionaryInfo = (data) => {
    return http({
        url: '/gzzc/dictionary/searchDictionaryInfo',
        method: 'post'
    }, data)
}

/* 机构列表 */
export const getOrganizationList = (data) => {
    return http({
        url: '/gzzc/backstageOrganization/getOrganizationList',
        method: 'post'
    }, data)
}

/* 新增案件 */
export const saveCase = (data) => {
    return http({
        url: '/gzzc/case/saveCase',
        method: 'post'
    }, data)
}

/* 新增在线庭审案件 */
export const addmediationMeeting = (data) => {
    return http({
        url: '/gzzc/case/addmediationMeeting',
        method: 'post'
    }, data)
}

/* 案件监管列表 */
export const monitorNewCaseList = (data) => {
    return http({
        url: '/scavenger/case/monitorNewCaseList',
        method: 'post'
    }, data)
}

/* 新增异步庭审、异步调解、在线送达案件 */
export const addAsynchronousMeeting = (data) => {
    return http({
        url: '/scavenger/case/addAsynchronousMeeting',
        method: 'post'
    }, data)
}

/* 导入问题单 */
export const analysisExcel = (data) => {
    return http({
        url: '/scavenger/case/analysisExcel',
        method: 'post'
    }, data)
}

/* 自动填充 */
export const getPersonInfoByIdCard = (data) => {
    return http({
        url: '/gzzc/case/getPersonInfoByIdCard',
        method: 'post'
    }, data)
}

/* 案件详情 */
export const getEnvCase = (data) => {
    return http({
        url: '/gzzc/envCase/getEnvCase',
        method: 'post'
    }, data)
}

/* 修改案件描述 */
export const editEnvCaseDescribe = (data) => {
    return http({
        url: '/gzzc/envCase/editEnvCaseDescribe',
        method: 'post'
    }, data)
}

/* 修改案件人员信息 */
export const editEnvCasePeople = (data) => {
    return http({
        url: '/gzzc/envCase/editEnvCasePeople',
        method: 'post'
    }, data)
}

/* 修改案件同步机构信息 */
export const editEnvCaseSyncOrgs = (data) => {
    return http({
        url: '/gzzc/envCase/editEnvCaseSyncOrgs',
        method: 'post'
    }, data)
}

/* 申请司法确认和诉讼相关字典 */
export const getSuitBaseInfoHz = (data) => {
    return http({
        url: '/arbit/suit/getSuitBaseInfoHz',
        method: 'post'
    }, data)
}

/* 案由 */
export const causeAction = (data, jsonfile) => {
    return http({
        url: '/arbit/lawCause/' + jsonfile,
        method: 'get'
    }, data)
}

/* 申请司法确认和诉讼保存 */
export const saveSuitHz = (data) => {
    return http({
        url: '/arbit/suit/saveSuitHz',
        method: 'post'
    }, data)
}

/* 司法确认详情和诉讼详情 */
export const suitDetail = (data) => {
        return http({
            url: '/arbit/suit/suitDetail',
            method: 'post'
        }, data)
    }
    /* 查询诉讼案件列表 */
export const getFiles = (data) => {
    return http({
        url: '/arbit/suit/getFiles',
        method: 'post'
    }, data)
}

/* 查询案件列表 */
export const queryEnvCase = (data) => {
    return http({
        url: '/gzzc/envCase/queryEnvCase',
        method: 'post'
    }, data)
}

/* 查询再审列表 */
export const newCaseList = (data) => {
    return http({
        url: '/scavenger/case/newCaseList',
        method: 'post'
    }, data)
}

/* 获取案件材料列表 */
export const queryEnvCaseMaterial = (data) => {
    return http({
        url: '/gzzc/envCaseMaterial/queryEnvCaseMaterial',
        method: 'post'
    }, data)
}

/* 案件材料保存（上传） */
export const saveEnvCaseMaterial = (data) => {
    return http({
        url: '/gzzc/envCaseMaterial/saveEnvCaseMaterial',
        method: 'post'
    }, data)
}

/* 案件材料删除 */
export const delEnvCaseMaterial = (data) => {
    return http({
        url: '/gzzc/envCaseMaterial/delEnvCaseMaterial',
        method: 'post'
    }, data)
}

/* 案件会议记录 */
export const queryMeetingRecordList = (data) => {
    return http({
        url: '/gzzc/meeting/queryMeetingRecordList',
        method: 'post'
    }, data)
}


/* 视频记录 */
export const getVideoList = (data) => {
    return http({
        url: '/gzzc/meeting/getVideoList',
        method: 'post'
    }, data)
}

/* 关闭案件 */
export const endEnvCase = (data) => {
    return http({
        url: '/gzzc/envCase/endEnvCase',
        method: 'post'
    }, data)
}

/* 重启案件 */
export const restartEnvCase = (data) => {
    return http({
        url: '/gzzc/envCase/restartEnvCase',
        method: 'post'
    }, data)
}

/* 关闭视频 */
export const closeMediationMeeting = (data) => {
    return http({
        url: '/gzzc/meeting/closeMediationMeeting',
        method: 'post'
    }, data)
}

/* 诉讼/司法列表(湖州) */
export const getJudicialConfirmList = (data) => {
        return http({
            url: '/arbit/suit/listSuitHz',
            method: 'post'
        }, data)
    }
    /* 诉讼列表 */
export const getSuitInfoListPage = (data) => {
    return http({
        url: 'userGateway/personalCenter/getSuitInfoListPage',
        method: 'post'
    }, data)

}
/* 模板下载接口*/
export const downloadTemplate = (data) => {
    return http({
        url: '/gzzc/docBook/clerkRecordDownload',
        method: 'post'
    }, data)
}

/* 案由 */
export const queryNations = (data) => {
    return http({
        url: '/scavenger/case/queryNations',
        method: 'get'
    }, data)
}
/* 导入当事人 */
export const analysisPersonExcel = (data) => {
    return http({
        url: '/scavenger/case/analysisPersonExcel',
        method: 'post'
    }, data)
}
